module.exports = __webpack_public_path__ + "static/media/ic_font_size_minus.c986aa57.svg";